/**
 * Copyright Aquera Inc 2023
 *
 * This source code is licensed under the BSD-3-Clause license found in the
 * LICENSE file in the root directory of this source tree.
 */

import { css } from 'lit';

/**
 * FieldGenerator CSS
 */
export const styles = css`
  :host {
    width: 100%;
    box-sizing: border-box;
    -webkit-font-smoothing: var(--nile-webkit-font-smoothing, var(--ng-webkit-font-smoothing));
    -moz-osx-font-smoothing: var(--nile-moz-osx-font-smoothing, var(--ng-moz-osx-font-smoothing));
    text-rendering: var(--nile-text-rendering, var(--ng-text-rendering));
  }

  .pointer-cursor {
    cursor: pointer;
  }
  .pointer-cursor-not-allowed {
    pointer-events: none;
  }

  .switcher__label {
    display: flex;
    align-items: center;
    color: inherit;
    color: var(--nile-colors-dark-900);
    font-family:var(--nile-font-family-serif);
    font-size: var(--nile-type-scale-3);
    font-style: normal;
    font-weight: var(--nile-font-weight-regular);
    line-height: var(--nile-line-height-xsmall);
    letter-spacing: 0.2px;
  }

  switcher-object-mapper:hover {
    display: flex;
  }

  .switcher-icon-container.current {
    background: var(--nile-colors-primary-100);
  }

  .switcher-container {
    display: flex;
  }

  .switcher-inline {
    gap: var(--nile-spacing-md);
  }

  .switcher-block {
    flex-direction: column;
  }

  .switcher-inline > :nth-child(2) {
    flex: 1;
    min-width: 0;
  }

  .switcher-icons-container {
    display: flex;
    margin-left: auto;
    gap: var(--nile-spacing-md);
    max-height: 38px;
    align-items: center;
  }

  .switcher-block > .switcher-icons-container {
    margin-left: auto;
  }

  .label-container {
    display: flex;
  }

  .switcher-icon-container {
    cursor: pointer;
    justify-content: center;
    display: flex;
    align-items: center;
    margin-bottom: var(--nile-spacing-sm);
    height: 28px;
    width: 28px;
    border-radius: var(--nile-radius-sm);
  }
  nile-radio {
    display: inline-block;
    padding-right: var(--nile-spacing-lg);
  }

  .switcher-object-mapper-icon {
    display: none;
  }
  .switcher-object-mapper:hover > .switcher-object-mapper-icon {
    display: block;
  }
  .switcher-object-mapper::part(input) {
    color: var(--nile-colors-primary-600);
    cursor: pointer;
  }

  .switcher-input--noborder::part(base) {
    border: none;
  }
  .switcher-object-mapper--noborder::part(base) {
    border: none;
  }

  .switcher-dropdown--noborder::part(combobox) {
    border: none;
  }

  .switcher-dropdown--noborder::part(expand-icon) {
    display: none;
  }
`;

export default [styles];
